
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersNight as ObiLightningHeavySleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-night.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-night',
   elementClass: ObiLightningHeavySleetShowersNightElement,
   events: {
     
   }
  });
 
 